// import React, { useEffect, useRef } from "react";
// import "./Takepictures.css";

// // images by https://unsplash.com/@gymxratpapii
// const images = [
//   'https://images.unsplash.com/photo-1750469381463-c3df58670d53?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8M3x8fGVufDB8fHx8fA%3D%3D',
//   'https://images.unsplash.com/photo-1750384630310-fc5274092cee?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NHx8fGVufDB8fHx8fA%3D%3D',
//   'https://images.unsplash.com/photo-1750384512992-8b6d26cdb279?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8Nnx8fGVufDB8fHx8fA%3D%3D',
//   'https://images.unsplash.com/photo-1750384516339-6d63bd8024c8?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8OHx8fGVufDB8fHx8fA%3D%3D',
//   'https://images.unsplash.com/photo-1750384513127-6e51fb7a28a7?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8OXx8fGVufDB8fHx8fA%3D%3D',
//   'https://images.unsplash.com/photo-1750384513407-6b8f35ba7c53?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTB8fHxlbnwwfHx8fHw%3D',
//   'https://images.unsplash.com/photo-1750384512936-aad97cec2276?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTF8fHxlbnwwfHx8fHw%3D',
//   'https://images.unsplash.com/photo-1750384513353-04a989037218?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTJ8fHxlbnwwfHx8fHw%3D',
//   'https://images.unsplash.com/photo-1748203188507-be535444f676?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MjJ8fHxlbnwwfHx8fHw%3D',
//   'https://images.unsplash.com/photo-1748203186953-034523403d3f?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MjF8fHxlbnwwfHx8fHw%3D',
//   'https://images.unsplash.com/photo-1748202297107-a8e5a51264e3?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NDB8fHxlbnwwfHx8fHw%3D',
// ]

// function Takepictures() {
//   const randomPos = (index) => {
//     const container = 600;
//     const imgSize = 180; // width of image
//     const max = container - imgSize;

//     const x = Math.random() * max;
//     const y = Math.random() * max;

//     return {
//       width: imgSize + "px",
//       position: "absolute",
//       top: y + "px",
//       left: x + "px",
//       zIndex: index,
//       animationDelay: `${index * 300}ms`, // <<< sequential fade (300ms each)
//     };
//   };

//   return (
//     <div className="Gbtakepictures_root">
//       <div className="Gbtakepictures_imgroot">
//         {images.map((src, i) => (
//           <img key={i} src={src} className="fade-card" style={randomPos(i)} />
//         ))}
//       </div>
//       <div className='Gbdrawings_subtitle' style={{  }}>
//       Capture every smile. Your guests can upload their photos to the guestbook and create lasting memories for you.
//       </div>
//     </div>
//   );
// }


// export default Takepictures;


import React, { useMemo } from "react";
import { useInView } from "../../../../config/commonfunctions";
import "./Takepictures.css";

const images_ = [
  'https://images.unsplash.com/photo-1750469381463-c3df58670d53?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXpah8M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8M3x8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1750384630310-fc5274092cee?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1750384512992-8b6d26cdb279?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8Nnx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1750384516339-6d63bd8024c8?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8OHx8fGVufDB8fHx8fA%3D%3D',
  
  'https://images.unsplash.com/photo-1750384512936-aad97cec2276?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTF8fHxlbnwwfHx8fHw%3D',
  'https://images.unsplash.com/photo-1750384513353-04a989037218?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTJ8fHxlbnwwfHx8fHw%3D',
  'https://images.unsplash.com/photo-1748203188507-be535444f676?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MjJ8fHxlbnwwfHx8fHw%3D',
  'https://images.unsplash.com/photo-1748203186953-034523403d3f?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MjF8fHxlbnwwfHx8fHw%3D',
  'https://images.unsplash.com/photo-1748202297107-a8e5a51264e3?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NDB8fHxlbnwwfHx8fHw%3D',
]
  // ... (rest of your 9 images)
// 'https://images.unsplash.com/photo-1750384513127-6e51fb7a28a7?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8OXx8fGVufDB8fHx8fA%3D%3D',
  // 'https://images.unsplash.com/photo-1750384513407-6b8f35ba7c53?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MTB8fHxlbnwwfHx8fHw%3D',

function Takepictures({images}) {

  const [isVisible, componentRef] = useInView({ threshold: 0.4 });

  // --- Configuration ---
  const CONTAINER_WIDTH = 600;
  const CONTAINER_HEIGHT = 600; // The new fixed height
  const NUM_COLS = 3;
  const NUM_IMAGES = images.length;
  const NUM_ROWS = Math.ceil(NUM_IMAGES / NUM_COLS); // 11 images / 3 columns = 4 rows


  const scatteredImages = useMemo(() => {

    const colWidth = CONTAINER_WIDTH / NUM_COLS; // 200px

    // Calculate the new row height based on the fixed container height
    // This ensures all 4 rows fit snugly within 450px
    const rowHeight = CONTAINER_HEIGHT / NUM_ROWS; // 450px / 4 = 112.5px

    // Oversize factor (125% of column width for horizontal overlap)
    const imgWidth = colWidth * 1.15;

    // Calculate image height based on the new compressed row height
    // We make it slightly taller than the row height to ensure vertical overlap
    const imgHeight = rowHeight * 1.15;

    return images.map((src, i) => {
      // 1. Grid Math
      const colIndex = i % NUM_COLS;
      const rowIndex = Math.floor(i / NUM_COLS);

      const xBase = (colIndex * colWidth) + (colWidth / 2);
      const yBase = (rowIndex * rowHeight) + (rowHeight / 2);

      // 2. Randomness (Jitter)
      // Jitter range is slightly compressed to avoid images escaping the 450px boundary
      const jitterX = (Math.random() - 0.5) * 40;
      const jitterY = (Math.random() - 0.5) * 40;

      // Rotate -12 to +12 degrees
      const rotation = (Math.random() - 0.5) * 24;

      return {
        src,
        style: {
          width: `${imgWidth}px`,
          height: `${imgHeight}px`, // Adjusted height
          position: "absolute",
          // Center the image around the base point + jitter
          left: `${xBase - (imgWidth / 2) + jitterX}px`,
          top: `${yBase - (imgHeight / 2) + jitterY}px`, // Use imgHeight here
          transform: `rotate(${rotation}deg)`,
          zIndex: Math.floor(Math.random() * 20),
          animationDelay: `${i * 100}ms`,
        }
      };
    });
  }, [images]);

  const animationTriggerClass = isVisible ? 'is-visible' : '';

  return (
    <div className="Gbtakepictures_root" style={{ display: 'flex', flexDirection: 'column', minHeight: 950, height: 950, paddingTop: 950 * 0.1 }}>
      <div 
        ref={componentRef} 
        className={`Gbtakepictures_imgroot ${animationTriggerClass}`} 
        style={{ height: `${CONTAINER_HEIGHT}px` }}
      >
        {scatteredImages.map((img, i) => (
          <img
            key={i}
            src={img.src}
            className="scatter-card"
            style={img.style}
            alt="memory"
          />
        ))}
      </div>
      <div className='Gbdrawings_subtitle' style={{ marginTop: 40 }}>
        Capture every smile. Your guests can upload their photos to the guestbook and create lasting memories for you.
      </div>
    </div>
  );
}

export default Takepictures;